import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useGoogleMap } from '@react-google-maps/api'

// Determine the bound of indonesia
// This value picked manually, you can freely adjust this value
const indonesiaBound = {
  northEast: {
    lat: 4.463729,
    lng: 140.990397
  },
  southWest: {
    lat: -9.756614,
    lng: 95.582856
  },
}

// Set the bound of the map
const SetMapBound = ({ markers, breadcrumbs }) => {
  const maps = useGoogleMap()

  // When visible markers changes, set the map bounds
  useEffect(() => {
    if (maps) {
      // eslint-disable-next-line no-undef
      const bounds = new google.maps.LatLngBounds()

      if (breadcrumbs.length > 0) {
        markers.forEach(marker => {
          bounds.extend(marker.coordinate)
        })

        maps.panTo(bounds.getCenter())
        // eslint-disable-next-line no-undef
        google.maps.event.addListenerOnce(maps, 'idle', () => {
          if (markers.length > 1) {
            maps.fitBounds(bounds, 50)
          } else {
            maps.fitBounds(bounds, 150)
          }
          maps.setCenter(bounds.getCenter())
        })
      } else {
        bounds.extend(indonesiaBound.northEast)
        bounds.extend(indonesiaBound.southWest)
        maps.fitBounds(bounds)
      }

      // maps.set('restriction', {
      //   latLngBounds: bounds,
      // })
    }
  }, [maps, markers, breadcrumbs])

  return null
}

SetMapBound.propTypes = {
  markers: PropTypes.array.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.array).isRequired
}

export { indonesiaBound, SetMapBound }
